module.exports = __webpack_public_path__ + "static/media/fire-fighter.b27f24b3.jpg";